import { render } from "./JustificationField.vue?vue&type=template&id=15aeaa22"
import script from "./JustificationField.vue?vue&type=script&lang=js"
export * from "./JustificationField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__